import {ILeadModalLeadType} from "../../../../application/types/lead/ILeadModalLeadType";
export const getGtmEcommerceOfferEventCategoryByLeadType = (leadType: ILeadModalLeadType) => {
    if (leadType === "simple") {
        return "simple_form";
    }
    return "standard";
};
